import { defineMessages } from "react-intl";

const messages = defineMessages({
  onlyMyActivities: {
    id: "activities.calendarView.userFilter.onlyMyActivities",
    defaultMessage: "Only show activities I created",
    description:
      "Sidebar user filter  - Only show activities I created - in Activities Calendar view",
  },
  subTitle: {
    id: "activities.calendarView.userFilter.subTitle",
    defaultMessage: "Show activities assigned to",
    description: "Sidebar user filter sub Title in Activities Calendar view",
  },
  subTitleNoAssigneeSelected: {
    id: "activities.calendarView.userFilter.subTitleNoAssigneeSelected",
    defaultMessage: "Please select a person to see a planner",
    description:
      "Sidebar user filter sub Title (if no assignee selected) in Activities Calendar view",
  },
  title: {
    id: "activities.calendarView.userFilter.title",
    defaultMessage: "Planners",
    description: "Sidebar user filter title in Activities Calendar view",
  },
});

export default messages;
